import type { ReactNode } from "react";

interface Props {
  /** 0–100 */
  value: number;
  /** 트랙 아래 상태 라벨 — "DEVELOPING · 34 / 100" 처럼 자간 넓은 대문자 */
  label: ReactNode;
  /** thick: 2px 트랙 + 그린 채움(인쇄). 기본 1px + 잉크(생성) */
  thick?: boolean;
  className?: string;
}

/** 헤어라인 진행 표시 (HERIT 04a/05b) — 전폭 트랙 + 채움 + 상태 라벨. */
export function HairlineProgress({ value, label, thick = false, className }: Props) {
  const v = Math.min(100, Math.max(0, Math.round(value)));
  const cls = ["hp", thick ? "hp--thick" : "", className ?? ""].filter(Boolean).join(" ");
  return (
    <div className={cls} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={v}>
      <div className="hp__track"><span style={{ width: `${v}%` }} /></div>
      <span className="status">{label}</span>
    </div>
  );
}
